import React, { useState, useMemo, useEffect } from 'react';
import { FiSearch, FiCheck, FiX, FiAlertTriangle, FiStar, FiUsers, FiCreditCard, FiLayout, FiList, FiGlobe } from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const EUR_RATE = 1.95583;

const translations = {
  bg: {
    title: "Ценова листа",
    subtitle: "Latin Force Dance Studio 2026-2027",
    searchPlaceholder: "Търси стил...",
    currency: "Валута",
    currencyBoth: "Двете",
    multiSport: "MultiSport",
    multiSportAll: "Всички",
    multiSportYes: "Да",
    multiSportNo: "Не",
    view: "Изглед",
    viewGrid: "Карти",
    viewTable: "Таблица",
    popular: "Популярен",
    multiSportAccepted: "MultiSport",
    multiSportNotAccepted: "Не се приема MultiSport",
    singleVisit: "Единично",
    card4: "Карта 4 пос.",
    card8: "Карта 8 пос.",
    noPackages: "Няма допълнителни пакети",
    noStyles: "Няма намерени стилове",
    style: "Стил",
    checkPricing: "Провери ценообразуването",
    noSpecificConditions: "Без специфични условия",
    copyright: "Latin Force © 2026-2027",
    lang: "Език",
    // Styles
    "Салса": "Салса",
    "Бачата": "Бачата",
    "Салса и бачата практика": "Салса и бачата практика",
    "Кизомба": "Кизомба",
    "Зук": "Зук",
    "Спортни танци": "Спортни танци",
    "Суинг": "Суинг",
    "Аржентинско танго": "Аржентинско танго",
    "Класически балет": "Класически балет",
    "Съвременен танц (60 мин.)": "Съвременен танц (60 мин.)",
    "Съвременен танц практика (30 мин.)": "Съвременен танц практика (30 мин.)",
    "Хип-хоп": "Хип-хоп",
    "K-поп": "K-поп",
    "HIGH HEELS": "HIGH HEELS",
    "Български народни танци": "Български народни танци",
    "Гръцки танци": "Гръцки танци",
    "Ориенталски танци": "Ориенталски танци",
    "Пилатес": "Пилатес",
    "Йогалатес": "Йогалатес",
    "Зумба": "Зумба",
    "STRONG Nation": "STRONG Nation",
    "Регетон": "Регетон",
    "Винг Чун": "Винг Чун",
    "Капоейра": "Капоейра",
    "Таекуондо": "Таекуондо",
    "Workshops": "Workshops",
    "Деца: K-поп": "Деца: K-поп",
    "Модерни танци за Деца": "Модерни танци за Деца",
    "Салса и Латино танци за Деца": "Салса и Латино танци за Деца",
    "Спортни и Латино танци за Деца": "Спортни и Латино танци за Деца",
    "Класически Балет за Деца": "Класически Балет за Деца",
    "Детски групи – Таекуондо": "Детски групи – Таекуондо",
    "Хип-Хоп за Деца": "Хип-Хоп за Деца",
    // Categories
    "all": "Всички",
    "latin": "Латино танци",
    "modern": "Модерни танци",
    "classic": "Класически танци",
    "folk": "Народни танци",
    "fitness": "Фитнес & Уелнес",
    "kids": "Деца",
    "martial": "Бойни изкуства",
    "workshop": "Workshops"
  },
  en: {
    title: "Pricing List",
    subtitle: "Latin Force Dance Studio 2026-2027",
    searchPlaceholder: "Search style...",
    currency: "Currency",
    currencyBoth: "Both",
    multiSport: "MultiSport",
    multiSportAll: "All",
    multiSportYes: "Yes",
    multiSportNo: "No",
    view: "View",
    viewGrid: "Cards",
    viewTable: "Table",
    popular: "Popular",
    multiSportAccepted: "MultiSport",
    multiSportNotAccepted: "MultiSport not accepted",
    singleVisit: "Single Visit",
    card4: "4 Visits Card",
    card8: "8 Visits Card",
    noPackages: "No additional packages",
    noStyles: "No styles found",
    style: "Style",
    checkPricing: "Check pricing",
    noSpecificConditions: "No specific conditions",
    copyright: "Latin Force © 2026-2027",
    lang: "Language",
    // Styles
    "Салса": "Salsa",
    "Бачата": "Bachata",
    "Салса и бачата практика": "Salsa & Bachata Practice",
    "Кизомба": "Kizomba",
    "Зук": "Zouk",
    "Спортни танци": "Sport Dance",
    "Суинг": "Swing",
    "Аржентинско танго": "Argentine Tango",
    "Класически балет": "Classical Ballet",
    "Съвременен танц (60 мин.)": "Contemporary Dance",
    "Съвременен танц практика (30 мин.)": "Contemporary Dance Practice",
    "Хип-хоп": "Hip-Hop",
    "K-поп": "K-pop",
    "HIGH HEELS": "HIGH HEELS",
    "Български народни танци": "Bulgarian Folk Dances",
    "Гръцки танци": "Greek Dances",
    "Ориенталски танци": "Oriental Dances",
    "Пилатес": "Pilates",
    "Йогалатес": "Yogalates",
    "Зумба": "Zumba",
    "STRONG Nation": "STRONG Nation",
    "Регетон": "Reggaeton",
    "Винг Чун": "Wing Chun",
    "Капоейра": "Capoeira",
    "Таекуондо": "Taekwondo",
    "Workshops": "Workshops",
    "Деца: K-поп": "Kids: K-pop",
    "Модерни танци за Деца": "Modern Dance for Kids",
    "Салса и Латино танци за Деца": "Salsa & Latin Dances for Kids",
    "Спортни и Латино танци за Деца": "Dance Sport & Latin Dances for Kids",
    "Класически Балет за Деца": "Classical Ballet for Kids",
    "Детски групи – Таекуондо": "Taekwondo for Kids",
    "Хип-Хоп за Деца": "Hip-Hop for Kids",
    // Categories
    "all": "All",
    "latin": "Latin Dances",
    "modern": "Modern Dance",
    "classic": "Classical Dances",
    "folk": "Folk Dances",
    "fitness": "Fitness & Wellness",
    "kids": "Kids",
    "martial": "Martial Arts",
    "workshop": "Workshops"
  }
};

const pricingData = [
  {
    style: "Салса",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "latin",
    popular: true
  },
  {
    style: "Бачата",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "latin",
    popular: true
  },
  {
    style: "Салса и бачата практика",
    single_bgn: 9.78,
    single_eur: 5.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "Самостоятелна практика без инструктор",
    multisport: true,
    category: "latin"
  },
  {
    style: "Кизомба",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "latin",
    popular: true
  },
  {
    style: "Зук",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "latin"
  },
  {
    style: "Спортни танци",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец",
    multisport: true,
    category: "sport"
  },
  {
    style: "Суинг",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "8 посещения – 2 месеца",
    multisport: true,
    category: "classic"
  },
  {
    style: "Аржентинско танго",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "classic"
  },
  {
    style: "Класически балет",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "classic",
    popular: true
  },
  {
    style: "Съвременен танц (60 мин.)",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "4 посещения – 2 месеца",
    multisport: true,
    category: "modern"
  },
  {
    style: "Съвременен танц практика (30 мин.)",
    single_bgn: 5.87,
    single_eur: 3.00,
    card4_bgn: 23.47,
    card4_eur: 12.00,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец",
    multisport: false,
    category: "modern"
  },
  {
    style: "Хип-хоп",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "8 посещения – 1 месец",
    multisport: true,
    category: "modern"
  },
  {
    style: "K-поп",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "modern",
    popular: true
  },
  {
    style: "HIGH HEELS",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "4 посещения – 2 месеца",
    multisport: false,
    category: "modern"
  },
  {
    style: "Български народни танци",
    single_bgn: 12.71,
    single_eur: 6.50,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 88.01,
    card8_eur: 45.00,
    other_packages: [],
    validity_notes: "8 посещения – 2 месеца",
    multisport: true,
    category: "folk",
    popular: true
  },
  {
    style: "Гръцки танци",
    single_bgn: 12.71,
    single_eur: 6.50,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 88.01,
    card8_eur: 45.00,
    other_packages: [],
    validity_notes: "8 посещения – 2 месеца",
    multisport: true,
    category: "folk"
  },
  {
    style: "Ориенталски танци",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "folk"
  },
  {
    style: "Пилатес",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "fitness",
    popular: true
  },
  {
    style: "Йогалатес",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "fitness"
  },
  {
    style: "Зумба",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "fitness",
    popular: true
  },
  {
    style: "STRONG Nation",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "fitness"
  },
  {
    style: "Регетон",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: true,
    category: "latin"
  },
  {
    style: "Винг Чун",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "8 посещения – 2 месеца",
    multisport: true,
    category: "martial"
  },
  {
    style: "Капоейра",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "4 посещения – 2 месеца",
    multisport: true,
    category: "martial"
  },
  {
    style: "Таекуондо",
    single_bgn: 17.60,
    single_eur: 9.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [
      {
        title: "Семейна карта",
        bgn: 192.00,
        eur: null,
        note: "валидност 2 месеца"
      }
    ],
    validity_notes: "8 посещения – 2 месеца",
    multisport: true,
    category: "martial"
  },
  {
    style: "Workshops",
    single_bgn: 17.60,
    single_eur: 9.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: null,
    card8_eur: null,
    other_packages: [],
    validity_notes: "Специализирани събития",
    multisport: true,
    category: "workshop",
    popular: true
  },
  {
    style: "Деца: K-поп",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "kids",
    popular: true
  },
  {
    style: "Модерни танци за Деца",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "kids"
  },
  {
    style: "Салса и Латино танци за Деца",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "kids"
  },
  {
    style: "Спортни и Латино танци за Деца",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [
      { title: "Семейна карта 16 пос.", eur: 98.00, bgn: 191.67 }
    ],
    validity_notes: "8 посещения – 2 месеца; 16 посещения – 2 месеца",
    multisport: false,
    category: "kids"
  },
  {
    style: "Класически Балет за Деца",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: 53.79,
    card4_eur: 27.50,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "4 посещения – 1 месец; 8 посещения – 2 месеца",
    multisport: false,
    category: "kids"
  },
  {
    style: "Детски групи – Таекуондо",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [
      { title: "Семейна карта 16 пос.", eur: 98.00, bgn: 191.67 }
    ],
    validity_notes: "8 посещения – 2 месеца; 16 посещения – 2 месеца",
    multisport: false,
    category: "kids"
  },
  {
    style: "Хип-Хоп за Деца",
    single_bgn: 15.65,
    single_eur: 8.00,
    card4_bgn: null,
    card4_eur: null,
    card8_bgn: 107.57,
    card8_eur: 55.00,
    other_packages: [],
    validity_notes: "8 посещения – 1 месец",
    multisport: false,
    category: "kids"
  }
];

const categories = [
  { id: 'all', name: 'Всички' },
  { id: 'latin', name: 'Латино танци' },
  { id: 'modern', name: 'Модерни танци' },
  { id: 'classic', name: 'Класически танци' },
  { id: 'folk', name: 'Народни танци' },
  { id: 'fitness', name: 'Фитнес & Уелнес' },
  { id: 'kids', name: 'Деца' },
  { id: 'martial', name: 'Бойни изкуства' },
  { id: 'workshop', name: 'Workshops' }
];

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('lf-lang') || 'bg');
  const [searchTerm, setSearchTerm] = useState('');
  const [currencyDisplay, setCurrencyDisplay] = useState('both');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [viewMode, setViewMode] = useState('grid');
  const [multiSportFilter, setMultiSportFilter] = useState('all');

  useEffect(() => {
    localStorage.setItem('lf-lang', lang);
  }, [lang]);

  const t = (key) => translations[lang][key] || key;

  const convertToEur = (bgn) => {
    if (!bgn) return null;
    return (bgn / EUR_RATE);
  };

  const formatPrice = (bgn, eur, currency = 'both') => {
    if (!bgn && !eur) return '—';
    
    const eurValue = eur || convertToEur(bgn);
    const bgnValue = bgn || (eur * EUR_RATE);
    
    if (currency === 'bgn') {
      return `${bgnValue.toFixed(2)} лв.`;
    } else if (currency === 'eur') {
      return `${eurValue.toFixed(2)} €`;
    } else {
      return `${eurValue.toFixed(2)} € / ${bgnValue.toFixed(2)} лв.`;
    }
  };

  const checkPriceConsistency = (item) => {
    if (!item.card4_bgn || !item.card8_bgn) return true;
    const pricePerVisit4 = item.card4_bgn / 4;
    const pricePerVisit8 = item.card8_bgn / 8;
    return pricePerVisit8 <= (pricePerVisit4 + 0.05);
  };

  const filteredData = useMemo(() => {
    return pricingData.filter(item => {
      const translatedName = t(item.style);
      const matchesSearch = translatedName.toLowerCase().includes(searchTerm.toLowerCase()) || 
                           item.style.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
      const matchesMultiSport = multiSportFilter === 'all' 
        ? true 
        : multiSportFilter === 'accepted' 
          ? item.multisport 
          : !item.multisport;
      
      return matchesSearch && matchesCategory && matchesMultiSport;
    });
  }, [searchTerm, selectedCategory, multiSportFilter, lang]);

  const StyleCard = ({ item }) => (
    <div className={`style-card ${item.popular ? 'popular' : ''}`}>
      {item.popular && (
        <div className="popular-badge">
          <SafeIcon icon={FiStar} /> {t('popular')}
        </div>
      )}
      
      <div className="card-header">
        <h3 className="style-name">{t(item.style)}</h3>
        <div className="multisport-status">
          {item.multisport ? (
            <div className="multisport-badge">
              <SafeIcon icon={FiCheck} /> <span>{t('multiSportAccepted')}</span>
            </div>
          ) : (
            <div className="no-multisport-badge">
              <SafeIcon icon={FiX} /> <span>{t('multiSportNotAccepted')}</span>
            </div>
          )}
        </div>
      </div>

      <div className="card-body">
        <div className="price-grid">
          <div className="price-item">
            <label>{t('singleVisit')}</label>
            <span className="price-value">{formatPrice(item.single_bgn, item.single_eur, currencyDisplay)}</span>
          </div>
          
          <div className="price-item">
            <label>{t('card4')}</label>
            <span className="price-value">{formatPrice(item.card4_bgn, item.card4_eur, currencyDisplay)}</span>
          </div>
          
          <div className="price-item">
            <label>{t('card8')}</label>
            <span className={`price-value ${!checkPriceConsistency(item) ? 'warning-price' : ''}`}>
              {formatPrice(item.card8_bgn, item.card8_eur, currencyDisplay)}
              {!checkPriceConsistency(item) && (
                <SafeIcon icon={FiAlertTriangle} className="warning-icon" title={t('checkPricing')} />
              )}
            </span>
          </div>
        </div>

        <div className="divider"></div>

        <div className="info-section">
          <div className="other-packages-list">
            {item.other_packages.length > 0 ? (
              item.other_packages.map((pkg, idx) => (
                <div key={idx} className="package-row">
                  <span className="pkg-label">{pkg.title}</span>
                  <span className="pkg-price">{formatPrice(pkg.bgn, pkg.eur, currencyDisplay)}</span>
                </div>
              ))
            ) : (
              <div className="other-packages-placeholder">{t('noPackages')}</div>
            )}
          </div>
          
          <div className="divider-mini"></div>

          <div className="validity-notes-container">
            {item.validity_notes ? (
              <div className="validity-text">
                <SafeIcon icon={FiUsers} className="info-icon" />
                <span>{item.validity_notes}</span>
              </div>
            ) : (
              <div className="validity-placeholder">{t('noSpecificConditions')}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-logo-container">
          <img src="https://media-manager-c.questera.ai/greta-media/fb32a88d657c0f351bdda43b98bfab4557e890af6f6d16e268f14ae8079c2a70ee4198eae3a341f5ce1e4f787fc5b382/images/aW1hZ2UvcG5n/5c301996e97a000506e0583fc54de2be.png" alt="Latin Force Logo" className="logo" />
        </div>
      </header>
      
      <main>
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">{t('title')}</h1>
            <h2 className="hero-subtitle">{t('subtitle')}</h2>
            <div className="controls-wrapper">
              <div className="search-container">
                <SafeIcon icon={FiSearch} className="search-icon" />
                <input
                  type="text"
                  placeholder={t('searchPlaceholder')}
                  className="search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="control-group">
                <div className="control-block">
                  <label className="control-label">{t('lang')}:</label>
                  <div className="toggle-group shadow-outset">
                    <button 
                      className={`toggle-btn ${lang === 'bg' ? 'active' : ''}`}
                      onClick={() => setLang('bg')}
                    >
                      <SafeIcon icon={FiGlobe} /> <span>BG</span>
                    </button>
                    <button 
                      className={`toggle-btn ${lang === 'en' ? 'active' : ''}`}
                      onClick={() => setLang('en')}
                    >
                      <SafeIcon icon={FiGlobe} /> <span>EN</span>
                    </button>
                  </div>
                </div>

                <div className="control-block">
                  <label className="control-label">{t('currency')}:</label>
                  <div className="toggle-group shadow-outset">
                    <button 
                      className={`toggle-btn ${currencyDisplay === 'both' ? 'active' : ''}`}
                      onClick={() => setCurrencyDisplay('both')}
                    >
                      {t('currencyBoth')}
                    </button>
                    <button 
                      className={`toggle-btn ${currencyDisplay === 'bgn' ? 'active' : ''}`}
                      onClick={() => setCurrencyDisplay('bgn')}
                    >
                      BGN
                    </button>
                    <button 
                      className={`toggle-btn ${currencyDisplay === 'eur' ? 'active' : ''}`}
                      onClick={() => setCurrencyDisplay('eur')}
                    >
                      EUR
                    </button>
                  </div>
                </div>

                <div className="control-block">
                  <label className="control-label">{t('multiSport')}:</label>
                  <div className="toggle-group shadow-outset">
                    <button 
                      className={`toggle-btn ${multiSportFilter === 'all' ? 'active' : ''}`}
                      onClick={() => setMultiSportFilter('all')}
                      title={t('multiSportAll')}
                    >
                      <SafeIcon icon={FiCreditCard} /> <span>{t('multiSportAll')}</span>
                    </button>
                    <button 
                      className={`toggle-btn ${multiSportFilter === 'accepted' ? 'active' : ''}`}
                      onClick={() => setMultiSportFilter('accepted')}
                      title={t('multiSportYes')}
                    >
                      <SafeIcon icon={FiCheck} /> <span>{t('multiSportYes')}</span>
                    </button>
                    <button 
                      className={`toggle-btn ${multiSportFilter === 'not-accepted' ? 'active' : ''}`}
                      onClick={() => setMultiSportFilter('not-accepted')}
                      title={t('multiSportNo')}
                    >
                      <SafeIcon icon={FiX} /> <span>{t('multiSportNo')}</span>
                    </button>
                  </div>
                </div>

                <div className="control-block">
                  <label className="control-label">{t('view')}:</label>
                  <div className="toggle-group shadow-outset">
                    <button 
                      className={`toggle-btn icon-only ${viewMode === 'grid' ? 'active' : ''}`}
                      onClick={() => setViewMode('grid')}
                      title={t('viewGrid')}
                    >
                      <SafeIcon icon={FiLayout} />
                    </button>
                    <button 
                      className={`toggle-btn icon-only ${viewMode === 'table' ? 'active' : ''}`}
                      onClick={() => setViewMode('table')}
                      title={t('viewTable')}
                    >
                      <SafeIcon icon={FiList} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="category-section">
          <div className="category-container">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {t(category.id)}
              </button>
            ))}
          </div>
        </div>

        <div className="content-section">
          {filteredData.length === 0 ? (
            <div className="empty-state">
              <SafeIcon icon={FiSearch} className="empty-icon" />
              <h3>{t('noStyles')}</h3>
            </div>
          ) : viewMode === 'grid' ? (
            <div className="styles-grid">
              {filteredData.map((item, index) => (
                <StyleCard key={index} item={item} />
              ))}
            </div>
          ) : (
            <div className="table-container">
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th>{t('style')}</th>
                    <th>{t('singleVisit')}</th>
                    <th>{t('card4')}</th>
                    <th>{t('card8')}</th>
                    <th>{t('multiSport')}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => (
                    <tr key={index} className={item.popular ? 'popular-row' : ''}>
                      <td className="style-cell">
                        <span className="style-name-table">{t(item.style)}</span>
                        {item.popular && <span className="popular-indicator">★</span>}
                      </td>
                      <td>{formatPrice(item.single_bgn, item.single_eur, currencyDisplay)}</td>
                      <td>{formatPrice(item.card4_bgn, item.card4_eur, currencyDisplay)}</td>
                      <td>{formatPrice(item.card8_bgn, item.card8_eur, currencyDisplay)}</td>
                      <td className="text-center">
                        {item.multisport ? (
                          <SafeIcon icon={FiCheck} className="check-icon" />
                        ) : (
                          <div className="no-multisport-table">
                            <SafeIcon icon={FiX} className="x-icon" />
                            <span className="sr-only">{t('multiSportNo')}</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
      
      <footer className="footer">
        <p>{t('copyright')}</p>
      </footer>
    </div>
  );
}

export default App;